module.exports = __webpack_public_path__ + "static/media/video-july.5b7dd9d1.jpg";